import { render, staticRenderFns } from "./PermisoCierreCaja.vue?vue&type=template&id=7244689c"
import script from "./PermisoCierreCaja.vue?vue&type=script&lang=js"
export * from "./PermisoCierreCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports